import React from "react";
import GenericB2BList, { B2B_TYPES } from "../B2B/GenericB2BList";
import B2BVoucherGiftModal from "../../../Components/modal/B2BVoucherGiftModal";

/**
 * B2B Voucher List - uses GenericB2BList with voucher configuration
 */
function B2BVoucherList({ todayOnly }) {
  return (
    <GenericB2BList
      type={B2B_TYPES.VOUCHER}
      GiftModalComponent={B2BVoucherGiftModal}
      todayOnly={todayOnly}
    />
  );
}

export default B2BVoucherList;
